var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseListHeader',[_c('div',{staticClass:"flex -mx-3 py-1 font-medium text-sm uppercase"},[_c('div',{staticClass:"flex-1 px-3"},[_vm._v("contact info")]),_c('div',{staticClass:"flex-1 px-3"},[_vm._v("project / stage")]),_c('div',{staticClass:"w-48 px-3 text-right"},[_vm._v("created")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }